import { createAction, props } from "@ngrx/store";
import { TaskFolder } from "./task-folder.model";

export const loadTaskFolders = createAction(
  "[TaskFolders] Load Task Folders"
);

export const loadTaskFoldersSuccess = createAction(
  "[TaskFolders] Load Task Folders Success",
  props<{ folders: TaskFolder[] }>()
);

export const loadTaskFoldersFailure = createAction(
  "[TaskFolders] Load Task Folders Failure",
  props<{ error: any }>()
);
